import { Injectable, Provider } from "@angular/core";
import { EFavoriteGetQueryType, EFavoriteOrigin, EFavoriteType, FavoriteClient, FavoriteDeleteCommand, FavoriteDeleteCommandResult, FavoriteDto, FavoriteGetQuery, FavoriteGetQueryResult, FavoriteSetCommand, FavoriteSetCommandResult, ProductFlatDto, ProductIdentifierDto } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";
import { IFavoriteApiService, IFavoriteApiServiceToken } from "./favorite-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class FavoriteApiService implements IFavoriteApiService {

  constructor(
    private favoriteClient: FavoriteClient,
  ) { }

  public swagFavoriteGet(favoriteGetQueryType: EFavoriteGetQueryType): Observable<FavoriteGetQueryResult> {
    let query = new FavoriteGetQuery({
      favoriteGetQueryType: favoriteGetQueryType,
    });

    return this.favoriteClient.favoriteGet(query);
  }

  public swagFavoriteSet(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<FavoriteSetCommandResult> {
    let favoriteDtoList: FavoriteDto[] = this.productIdentifierToFavoriteMapping(productIdentifierList, favoriteType);

    let command = new FavoriteSetCommand({
      favoriteList: favoriteDtoList,
      favoriteOrigin: EFavoriteOrigin.Manually
    });

    return this.favoriteClient.favoriteSet(command);
  }

  public swagFavoriteDelete(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): Observable<FavoriteDeleteCommandResult> {
    let favoriteDtoList: FavoriteDto[] = this.productIdentifierToFavoriteMapping(productIdentifierList, favoriteType);

    let command = new FavoriteDeleteCommand({
      favoriteList: favoriteDtoList,
    });

    return this.favoriteClient.favoriteDelete(command);
  }

  private productIdentifierToFavoriteMapping(productIdentifierList: ProductIdentifierDto[], favoriteType?: EFavoriteType | undefined): FavoriteDto[] {
    let favoriteDtoList: FavoriteDto[] = [];

    productIdentifierList.forEach(
      (productIdentifier: ProductIdentifierDto) => {

        let productFlat = new ProductFlatDto();
        productFlat.productIdentifier = productIdentifier;

        if (favoriteType == undefined) {
          favoriteType = EFavoriteType.Personal;
        }

        favoriteDtoList.push(new FavoriteDto({
          favoriteType: favoriteType,
          productFlat: productFlat,
        }));
      }
    );

    return favoriteDtoList;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const FavoriteApiServiceProvider: Provider[] = [
  { provide: FavoriteClient },
  { provide: IFavoriteApiServiceToken, useExisting: FavoriteApiService }
];
